import { getUnreadLuckyDrops } from '@/api'
import { useLuckyDropStore } from '@/store/luckyDrop'
import { useUserStore } from '@/store/user'

function isApiOk(res) {
  return res != null && (Number(res.code) === 200 || res.code === '200')
}

/** 购买等接口响应内携带的 luckyDrop */
export function handleLuckyDropFromResponse(res) {
  if (!res) return false
  const payload = res.luckyDrop ?? res.data?.luckyDrop
  if (!payload) return false
  return useLuckyDropStore().present(payload)
}

/** 轮询未展示掉落（卖家成交、切页后补弹） */
let pollTimer = null
let lastPollAt = 0

export async function pollUnreadLuckyDrops() {
  if (!useUserStore().isLoggedIn()) return false
  const store = useLuckyDropStore()
  if (store.visible) return false

  const now = Date.now()
  if (now - lastPollAt < 1500) return false
  lastPollAt = now

  if (pollTimer) {
    clearTimeout(pollTimer)
    pollTimer = null
  }

  return new Promise((resolve) => {
    pollTimer = setTimeout(async () => {
      pollTimer = null
      if (store.visible) {
        resolve(false)
        return
      }
      try {
        const res = await getUnreadLuckyDrops()
        if (!isApiOk(res)) {
          resolve(false)
          return
        }
        const rows = res.data || res.rows || []
        if (!rows.length) {
          resolve(false)
          return
        }
        resolve(store.present(rows))
      } catch (e) {
        resolve(false)
      }
    }, 300)
  })
}
